import { render, staticRenderFns } from "./AnswerListItem.vue?vue&type=template&id=3cf79625&scoped=true&"
import script from "./AnswerListItem.vue?vue&type=script&lang=js&"
export * from "./AnswerListItem.vue?vue&type=script&lang=js&"
import style0 from "./AnswerListItem.vue?vue&type=style&index=0&id=3cf79625&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf79625",
  null
  
)

export default component.exports